"use client";
import { type FormEvent, useState } from "react";
import { Field } from "../../../components/fields";
import { Button, ButtonLink, Page, Status, TextLink, styles as s } from "../../../components/ui";
import { call, errorText } from "../../../lib/api-client";
import { useSubmit } from "../../../lib/use-submit";

type LoginResult = { needs_selection: boolean };

export function LoginForm({ lineEnabled }: { lineEnabled: boolean }) {
  const [step, setStep] = useState<"phone" | "code">("phone");
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [sent, setSent] = useState(false);
  const f = useSubmit();

  const request = (e?: FormEvent) => {
    e?.preventDefault();
    return f.run(async () => {
      const r = await call("POST", "/api/auth/otp/request", { phone });
      if (!r.ok) return f.setError(errorText(r.error));
      setStep("code");
      setSent(true);
    });
  };
  const verify = (e: FormEvent) => {
    e.preventDefault();
    return f.run(async () => {
      const r = await call<LoginResult>("POST", "/api/auth/otp/verify", { phone, code });
      if (!r.ok) return f.setError(errorText(r.error));
      window.location.href = r.data.needs_selection ? "/select" : "/";
    });
  };

  if (step === "code") {
    return (
      <Page title="確認コードの入力" lead={`${phone} に、ショートメール（SMS）で6けたの確認コードを送りました。届くまで1分ほどかかることがあります。`}>
        {sent && !f.error && <Status tone="info">ご登録の番号であれば、確認コードが届きます。</Status>}
        {f.error && <Status tone="error">{f.error}</Status>}
        <form className={s.form} onSubmit={verify}>
          <Field label="確認コード（6けた）" big inputMode="numeric" autoComplete="one-time-code" maxLength={6} pattern="[0-9]{6}" value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} required />
          <Button type="submit" variant="primary" block disabled={f.busy || code.length !== 6}>ログインする</Button>
        </form>
        <div>
          <Button onClick={() => request()} disabled={f.busy}>確認コードをもう一度送る</Button>
        </div>
        <TextLink href="/login">電話番号を入れ直す</TextLink>
      </Page>
    );
  }

  return (
    <Page title="ログイン" lead="登録した電話番号を入れてください。確認コード（6けたの数字）をショートメール（SMS）でお送りします。">
      {f.error && <Status tone="error">{f.error}</Status>}
      <form className={s.form} onSubmit={request}>
        <Field label="電話番号" type="tel" inputMode="tel" autoComplete="tel" value={phone} onChange={(e) => setPhone(e.target.value)} required hint="ハイフン（-）は入れても入れなくても大丈夫です。" />
        <Button type="submit" variant="primary" block disabled={f.busy || !phone}>確認コードを送る</Button>
      </form>
      {lineEnabled && (
        <>
          <p className={s.divider}>または</p>
          <ButtonLink variant="line" block href="/liff" external>LINEでログイン</ButtonLink>
          <p className={s.hint}>LINE で登録した方は、こちらからログインできます。</p>
        </>
      )}
      <div>
        <TextLink href="/register">はじめての方（新規登録）</TextLink>
        <TextLink href="/phone">電話番号を変えた方</TextLink>
        <TextLink href="/family/login">ご家族の方（メールでログイン）</TextLink>
      </div>
    </Page>
  );
}
